module.exports = __webpack_public_path__ + "img/youtube.35acfb94.png";